module.exports = __webpack_public_path__ + "img/mobile scanner stand-04.7ec22751.png";